import { ReactElement } from 'react';
import { Box, Stack, Typography } from '@mui/material';

type MetaItemProps = {
  icon: ReactElement;
  label: string;
};

const MetaItem = ({ icon, label }: MetaItemProps) => (
  <Stack direction="row" spacing={0.75} alignItems="center" sx={{ minWidth: 0 }}>
    <Box sx={{ display: 'flex', color: 'text.disabled', '& .MuiSvgIcon-root': { fontSize: 16 } }}>{icon}</Box>
    <Typography variant="caption" color="text.secondary" noWrap>
      {label}
    </Typography>
  </Stack>
);

export default MetaItem;
